import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import { postData } from "../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { MotorRTOForm } from "./components/motorRTOForm";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const AddMotorRTO = () => {

  const navigate = useNavigate();
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  const handleAddRTO = async (rtoData) => {
    setCircleLoading(true);
    const payload = {
      name: rtoData?.name,
      rtoCode: rtoData?.rtoCode,
      cityId: rtoData?.city?.value,
      rtoZoneId: rtoData?.rtoZone?.value,
      rtoRegionId: rtoData?.rtoRegion?.value,
      isActive: rtoData?.isActive,
    };

    try {
      const response = await postData("/reference/motor/rto", payload);
      if(response?.success){
        navigate("/motor-master/motor-RTO");
        showSnackbar(response?.message,"success")
      }          
    }catch(error){
      console.error("Error fetching data",error)
      showSnackbar(error?.response?.data?.message, "error");
    }
    finally{
      setCircleLoading(false)
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton onClick={() => navigate("/motor-master/motor-RTO")}>
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add RTO Details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Add RTO details according to the State, District, City, RTO Region and RTO Zone here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <MotorRTOForm onsubmit={handleAddRTO} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default AddMotorRTO;
